import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BankCardApiService, CardProfile } from '@client-monorepo/daily-fintech/bank-card';
import { PayClientApiService } from '@client-monorepo/payment/purchase';

@Injectable({
  providedIn: 'root',
})
export class C2cSourceCardService {
  sourceCardProfile: BehaviorSubject<CardProfile | null> = new BehaviorSubject<CardProfile | null>(null);
  externalRegisterDescription: BehaviorSubject<string> = new BehaviorSubject<string>('');
  vaultCert!: string;

  constructor(
    private bankCardApiService: BankCardApiService,
    private payClientApiService: PayClientApiService,
  ) {}

  getVaultCertFile(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.payClientApiService.getCertFile(this.vaultCert).subscribe(
        (certText) => {
          resolve(certText);
        },
        (e) => {
          reject(e);
        },
      );
    });
  }

  getCardConfig() {
    this.bankCardApiService.getC2cConfig().subscribe((data) => {
      this.vaultCert = data.vaultCert;
      this.externalRegisterDescription.next(data.externalRegisterDescription);
    });
  }
}
